//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers as vuexModule } from 'vuex';
import { EventNames, track } from 'utils/analytics';
import PremiumAppIcon from 'images/premium-app-icon.svg';

import IntegrationIcon from 'components/IntegrationIcon.vue';
import * as liveChat from 'utils/live-chat';
import { VALUE_COPY } from 'store/modules/moduleWebTracking/moduleCreateTrackingLinks/actionTypes';
import {
	FEATURES_GET
} from 'store/modules/user/actionTypes';
import { EmailTools, EmailToolLabels } from '../../constants';
import { composeNewUrl } from '../../utils';

const OTHER = 'other';

const {
	mapActions
} = vuexModule('moduleWebTracking/moduleCreateTrackingLinks');

const userHelpers = vuexModule('user');

export default {
	components: {
		IntegrationIcon,
		PremiumAppIcon
	},

	data: () => ({
		emailTool: '',
		learnMoreLink: 'https://support.outfunnel.com/en/articles/6853713-identify-leads-from-any-email-marketing-tool',
		// eslint-disable-next-line max-len
		learnHowLink: 'https://support.outfunnel.com/en/articles/6853713-identify-leads-from-any-email-marketing-or-sales-enablement-tool#h_4ed03aa9f4',
		url: ''
	}),

	computed: {
		...userHelpers.mapGetters([
			'areFeaturesLoaded'
		]),

		...userHelpers.mapState([
			'features'
		]),

		isWebTrackingEnabled() {
			return this.features?.webTracking?.enabled;
		},

		emailTools() {
			const emailTools = Object.keys(EmailToolLabels).map(key => ({
				name: EmailToolLabels[key],
				value: key
			}));

			emailTools.push({ name: 'Other', value: OTHER });

			return emailTools;
		},

		isMailchimpSelected() {
			return this.emailTool === EmailTools.MAILCHIMP;
		},

		composedUrl() {
			if (!this.emailTool) {
				return;
			}

			if (this.emailTool === OTHER) {
				return;
			}

			return composeNewUrl(this.emailTool, this.url) || '';
		}
	},

	async mounted() {
		if (!this.areFeaturesLoaded) {
			this.FEATURES_GET();
		}
	},

	methods: {
		...mapActions([VALUE_COPY]),

		...userHelpers.mapActions([
			FEATURES_GET
		]),

		copyEmailLink() {
			this.highlightGeneratedLink();

			this.VALUE_COPY();
		},

		onEmailToolFocus() {
			this.copyEmailLink();
			this.sendTrackingLinkGeneratedEvent(this.emailTool);
		},

		highlightGeneratedLink() {
			this.$refs.referenceToLinkTextField.$refs.input.select();
		},

		onEmailToolChange() {
			if (this.emailTool === OTHER) {
				this.openIntercom();
			}
		},

		sendTrackingLinkGeneratedEvent(appName) {
			track({
				event: EventNames.TRACKING_LINK_GENERATED,
				properties: {
					url: this.composedUrl,
					selectedAppSlug: appName
				}
			});
		},

		openIntercom() {
			liveChat.showNewMessageChatWindow();
		}
	}
};
